module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticStyle: {
      "padding": "0px 20px 20px 20px"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "14px"
    },
    attrs: {
      "src": "static/images/amigo.png",
      "width": "80",
      "height": "80",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Hey Amigo")]), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_vm._v("\n            I thought I was blind!"), _c('br'), _vm._v("You have "), _c('b', [_vm._v(_vm._s(_vm.oldTasks.length))]), _vm._v(" tasks here that are more than 30 days expired. Want me to kill them?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pa-2 red--text"
  }, [_vm._v("\n            " + _vm._s(_vm.clients) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "tw-action",
    on: {
      "click": function($event) {
        _vm.moreTime = true
      }
    }
  }, [_vm._v("give me more time")]), _vm._v(" "), _c('v-btn', {
    staticClass: "tw-action error",
    on: {
      "click": _vm.killOldTasks
    }
  }, [_vm._v("take them out")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4478cf9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TaskWarnings.vue
// module id = 2527
// module chunks = 1